class ProductInfoDrawer extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.overlay = this.querySelector('.product-info-drawer__overlay');
    this.closeButton = this.querySelector('.product-info-drawer__close');

    this.tabs = this.querySelectorAll('.product-info-drawer__tab');
    this.panels = this.querySelectorAll('.product-info-drawer__panel-content');
    this.tabsNav = this.querySelector('.product-info-drawer__tabs');

    this.overlay?.addEventListener('click', () => this.close());
    this.closeButton?.addEventListener('click', () => this.close());

    this.transformSpecifications();
    this.initDraggableTabs();

    this.tabs.forEach((tab) => {
      tab.addEventListener('click', this.onTabClick);
    });
  }

  disconnectedCallback() {
    this.tabs?.forEach((tab) => tab.removeEventListener('click', this.onTabClick));
    this.tabsNav?.removeEventListener('wheel', this.onTabsWheel);
    this.tabsNav?.removeEventListener('pointerdown', this.onTabsPointerDown);
    window.removeEventListener('pointermove', this.onTabsPointerMove);
    window.removeEventListener('pointerup', this.onTabsPointerUp);
  }

  onTabClick = (event) => {
    // Suppress the click that fires at the end of a drag gesture
    if (this.tabsDragged) {
      this.tabsDragged = false;
      return;
    }
    this.activateTab(event.currentTarget.dataset.tab);
  };

  initDraggableTabs() {
    if (!this.tabsNav) return;

    // 1. Vertical wheel input -> horizontal scroll (fixes Windows mice)
    this.onTabsWheel = (event) => {
      if (event.deltaY === 0) return; // already horizontal (Mac trackpad) — let native handle it
      event.preventDefault();
      this.tabsNav.scrollLeft += event.deltaY;
    };
    this.tabsNav.addEventListener('wheel', this.onTabsWheel, { passive: false });

    // 2. Pointer drag-to-scroll (mouse click-drag, works cross-platform)
    this.tabsPointerActive = false;
    this.tabsDragged = false;
    this.tabsStartX = 0;
    this.tabsStartScrollLeft = 0;

    this.onTabsPointerDown = (event) => {
      this.tabsPointerActive = true;
      this.tabsDragged = false;
      this.tabsStartX = event.clientX;
      this.tabsStartScrollLeft = this.tabsNav.scrollLeft;
      this.tabsNav.classList.add('is-dragging');
    };

    this.onTabsPointerMove = (event) => {
      if (!this.tabsPointerActive) return;
      const delta = event.clientX - this.tabsStartX;

      if (Math.abs(delta) > 4) this.tabsDragged = true; // drag threshold before suppressing click
      this.tabsNav.scrollLeft = this.tabsStartScrollLeft - delta;
    };

    this.onTabsPointerUp = () => {
      this.tabsPointerActive = false;
      this.tabsNav.classList.remove('is-dragging');
    };

    this.tabsNav.addEventListener('pointerdown', this.onTabsPointerDown);
    window.addEventListener('pointermove', this.onTabsPointerMove);
    window.addEventListener('pointerup', this.onTabsPointerUp);
  }

  open(tab = 'quick-stats') {
    this.classList.add('is-open');
    document.documentElement.classList.add('product-info-drawer-open');
    this.activateTab(tab);
  }

  close() {
    this.classList.remove('is-open');
    document.documentElement.classList.remove('product-info-drawer-open');
  }

  activateTab(tabName) {
    this.tabs.forEach((tab) => {
      const isActive = tab.dataset.tab === tabName;
      tab.classList.toggle('is-active', isActive);
      tab.setAttribute('aria-selected', isActive);
    });

    this.panels.forEach((panel) => {
      const isActive = panel.dataset.panel === tabName;
      panel.classList.toggle('is-active', isActive);
      panel.hidden = !isActive;
    });

    this.activeTab = tabName;
  }

  transformSpecifications() {
    const container = this.querySelector('.product--specifications');
    if (!container) return;

    const table = container.querySelector('table');
    if (!table) return;

    const wrapper = document.createElement('div');

    table.querySelectorAll('tr').forEach((row) => {
      const heading = row.querySelector('th');
      const cells = row.querySelectorAll('td');

      if (heading) {
        const h3 = document.createElement('h3');
        h3.textContent = heading.textContent.trim();
        wrapper.appendChild(h3);
        return;
      }

      if (cells.length === 2) {
        const p = document.createElement('p');

        p.innerHTML = `
          <strong>${cells[0].textContent.trim()}</strong>
          ${cells[1].textContent.trim()}
        `;

        wrapper.appendChild(p);
      }
    });

    container.replaceChildren(wrapper);
  }
}

if (!customElements.get('product-info-drawer')) {
  customElements.define('product-info-drawer', ProductInfoDrawer);
}